import { IHpSobSnapshot } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSobSnapshot'

export const formHpSobFromFinancialData = (initialData: IHpSobSnapshot[]) => {
  const uniqueBusinessUnits = [
    ...new Set(initialData.filter((el) => el.BusinessUnit).map((el) => el.BusinessUnit)),
  ]

  return uniqueBusinessUnits.map((businessUnit) => {
    const categoriesData = initialData
      .filter((el) => el.BusinessUnit === businessUnit)
      .map((el) => {
        return {
          Category: el.Category,
          SobActuals22Q1: el.SobActuals22Q1,
          SobActuals22Q2: el.SobActuals22Q2,
          SobActuals22Q3: el.SobActuals22Q3,
          SobActuals22Q4: el.SobActuals22Q4,
          SobActuals23Q1: el.SobActuals23Q1,
          SobActuals23Q2: el.SobActuals23Q2,
          SobActuals23Q3: el.SobActuals23Q3,
          SobActuals23Q4: el.SobActuals23Q4,
        }
      })

    return {
      BusinessUnit: businessUnit,
      CategoriesData: categoriesData,
    }
  })
}
